export default {
    generate: {
        method: 'POST',
        url: '/admin/prizeRedemption/generate',
        name: '奖品兑换码生成',
    },
    generateList: {
        method: 'POST',
        url: '/admin/prizeRedemption/index',
        name: '奖品兑换码管理分页',
    },
    details: {
        method: 'POST',
        url: '/admin/prizeRedemption/details',
        name: '查看兑换码详情',
    },
    downloadZip: {
        method: 'POST',
        url: '/admin/prizeRedemption/downloadZip',
        name: '奖品兑换码打包下载',
    },
    statistics: {
        method: 'GET',
        url: '/admin/prizeRedemption/statistics/{prizeRedemptionId}',
        name: '兑换活动详情统计',
    },
    prizeList: {
        method: 'POST',
        url: '/admin/prizeRedemption/prizeList',
        name: '奖品兑换码管理奖品列表',
    },
    export: {
        method: 'POST',
        url: '/admin/prizeRedemption/details/export',
        name: '查看兑换码详情分页导出',
    },
    newCouponList: {
        method: 'POST',
        url: '/manage-system/coupon/admin/list',
        name: '分页查询优惠券列表',
    },
    newCouponAdd: {
        method: 'POST',
        url: '/manage-system/coupon/admin/add',
        name: '新增优惠券',
    },
    newCouponEdit: {
        method: 'POST',
        url: '/manage-system/coupon/admin/modify',
        name: '编辑优惠券',
    },
    couponShowCount: {
        method: 'GET',
        url: '/manage-system/coupon/admin/coupon/{id}',
        name: '领取用户列表页面数量接口',
    },
    getTicket: {
        method: 'POST',
        url: '/admin/newCoupon/getTicket',
        name: '系统票券',
    },
    couponState: {
        method: 'POST',
        url: '/manage-system/coupon/admin/forbiddenCoupon',
        name: '禁用',
    },
    couponShow: {
        method: 'POST',
        url: '/manage-system/coupon/admin/userList',
        name: '领取用户查看列表',
    },
    newCouponDetail: {
        method: 'GET',
        url: '/manage-system/coupon/admin/new/{id}',
        name: '优惠券详情',
    },
    newCouponDelete: {
        method: 'DELETE',
        url: '/manage-system/coupon/admin/{id}',
        name: '删除优惠券',
    },
    addActivity: {
        method: 'POST',
        url: '/admin/activity/addActivity',
        name: '新增活动',
    },
    editActivity: {
        method: 'PUT',
        url: '/admin/activity',
        name: '编辑活动',
    },
    detailActivity: {
        method: 'GET',
        url: '/admin/activity/{id}',
        name: '活动详情',
    },
    listActivity: {
        method: 'POST',
        url: '/admin/activity/list',
        name: '活动列表',
    },
    stateActivity: {
        method: 'PUT',
        url: '/admin/activity/state',
        name: '上线/下线',
    },
    codeList: {
        method: 'POST',
        url: '/admin/activity/codeList',
        name: '获取二维码库列表',
    },
    deleteActivity: {
        method: 'DELETE',
        url: '/admin/activity/{id}',
        name: '删除活动',
    },
    deposit: {
        method: 'POST',
        url: '/admin/activity/deposit',
        name: '获取所有未绑定的定金活动列表',
    },
    queryNewCoupon: {
        method: 'POST',
        url: '/manage-system/coupon/admin/queryCouponList',
        name: '查询新优惠券列表',
    },
    sendNewCoupon: {
        method: 'POST',
        url: '/manage-system/coupon/admin/sendNewCoupon',
        name: '发送新优惠券',
    },
    activityOrderList: {
        method: 'POST',
        url: '/admin/activityOrder/list',
        name: '营销订单列表',
    },
    activityOrderRefund: {
        method: 'POST',
        url: '/admin/activityOrder/orderRefund',
        name: '营销订单退款',
    },
    activityOrderState: {
        method: 'PUT',
        url: '/admin/activityOrder/state',
        name: '营销订单禁用/取消禁用',
    },
    activityOrderDetail: {
        method: 'GET',
        url: '/admin/activityOrder/{id}',
        name: '营销订单详情',
    },
    activityOrderExport: {
        method: 'POST',
        url: '/admin/activityOrder/export',
        name: '导出营销订单',
    },
    entranceTicketInfo: {
        method: 'POST',
        url: '/admin/ticketGive/entranceTicketInfo',
        name: '获取线上票（过滤餐票）',
    },
    getOnlineTicket: {
        method: 'POST',
        url: '/manage-system/ticket/queryTicketTemplateInfoPage',
        name: '获取线上票',
    },
    getOfflineTicket: {
        method: 'GET',
        url: '/admin/ticketGive/shopTocketInfo/{shopId}',
        name: '获取线下票',
    },
    courseListByShopId: {
        method: 'GET',
        url: '/admin/ticketGive/courseListByShopId/{shopId}',
        name: '根据门店id查询门店课程',
    },
    getGiveGoods: {
        method: 'GET',
        url: '/admin/ticketGive/queryGiftByType/{type}/{secondType}',
        name: '根据赠品类型获取赠品',
    },
    addTicketGive: {
        method: 'POST',
        url: '/manage-system/give/admin/addGive',
        name: '新增活动',
    },
    editTicketGive: {
        url: "/manage-system/give/admin/modifyGive",
        method: 'POST',
        name: '编辑活动',
    },
    changeGiftNum: {
        url: "/manage-system/ticketGive/stock/addGiveStockManage",
        method: 'POST',
        name: '后台加减库存',
    },
    ticketGiveList: {
        method: 'POST',
        url: '/manage-system/give/admin/giveList',
        name: '活动列表',
    },
    showGive: {
        method: 'GET',
        url: '/manage-system/give/admin/showGive/{id}',
        name: '查看活动赠品及规则',
    },
    state: {
        method: 'PUT',
        url: '/manage-system/give/admin/state',
        name: '上下架',
    },
    delInfo: {
        method: 'POST',
        url: '/manage-system/give/admin/delInfo',
        name: '删除活动',
    },
    ticketGiveOrder: {
        method: 'POST',
        url: '/manage-system/give/admin/ticketGiveOrder',
        name: '售卖明细',
    },
    ticketGiveOrderExports: {
        method: 'POST',
        url: '/manage-system/give/admin/export',
        name: '导出售卖明细',
    },
    addOrModifyDiscount: {
        method: 'POST',
        url: '/manage-system/discount/admin/addOrModify',
        name: '票台折扣新增/修改',
    },
    deleteDiscount: {
        method: 'GET',
        url: '/manage-system/discount/admin/delete/{id}',
        name: '删除票台折扣',
    },
    stateDiscount: {
        method: 'GET',
        url: '/manage-system/discount/admin/discountShelve/{discountId}/{shelve}',
        name: '票台折扣上下架操作(shelve:0下架；1上架)',
    },
    discountList: {
        method: 'POST',
        url: '/manage-system/discount/admin/list',
        name: '票台折扣管理列表',
    },
    detailDiscount: {
        method: 'GET',
        url: '/manage-system/discount/admin/{id}',
        name: '票台折扣详情',
    },
    getTicketList: {
        method: 'POST',
        url: '/admin/ticket/list/noSellNum',
        name: '票券列表',
    },
    exchangeGiftAdd: {
        method: 'POST',
        url: '/activity-center-groups/coupon/save',
        name: '新增礼券',
    },
    exchangeGiftEdit: {
        method: 'POST',
        url: '/activity-center-groups/coupon/update',
        name: '编辑礼券',
    },
    exchangeGiftDetail: {
        method: 'GET',
        url: '/activity-center-groups/coupon/detail/{id}',
        name: '礼券详情-编辑用',
    },
    exchangeGiftList: {
        method: 'GET',
        url: '/activity-center-groups/coupon/page',
        name: '礼券列表分页',
    },
    disableOrOpen: {
        method: 'GET',
        url: '/activity-center-groups/coupon/disableOrOpen',
        name: '根据id启用禁用礼券 isOpen=1 启用',
    },
    exchangeGiftDelete: {
        method: 'DELETE',
        url: '/activity-center-groups/coupon/delete',
        name: '根据id删除礼券',
    },
    exchangeGiftDetails: {
        method: 'GET',
        url: '/activity-center-groups/coupon/detail',
        name: '获取详情',
    },
    exchangeGiftDownloadMake: {
        method: 'GET',
        url: '/activity-center-groups/coupon/make',
        name: '优惠券生成下载记录',
    },
    exchangeGiftDownload: {
        method: 'GET',
        url: '/activity-center-groups/coupon/download',
        name: '优惠券下载',
    },
    exchangeGiftDownloadList: {
        method: 'GET',
        url: '/activity-center-groups/coupon/downloadList',
        name: '优惠券下载记录列表',
    },
    cashCodeList: {
        method: 'POST',
        url: '/activity-center-groups/coupon/cashCodeList',
        name: '兑换活动详情列表',
    },
    cashOrderList: {
        method: 'GET',
        url: '/activity-center-groups/coupon/cashOrderList',
        name: '兑换订单查询',
    },
    disableOrOpenBatch: {
        method: 'GET',
        url: '/activity-center-groups/coupon/cashCode/disableOrOpen',
        name: '兑换页面批量禁用解禁 ids ,分割',
    },
    getGoodRemainNum: {
        method: 'GET',
        url: '/activity-center-groups/coupon/getGoodRemainNum',
        name: '获取商品剩余数量 剩余数量 -1 不限制库存或没找到剩余库存',
    },
    couponGroupOrder: {
        method: 'POST',
        url: '/activity-center-groups/coupon-group-order/pageByCondition',
        name: '团购订单',
    },
    initGroupOrder: {
        method: 'POST',
        url: '/activity-center-groups/coupon-group-order/init',
        name: '初始化团购订单',
    },
    createGroupOrder: {
        method: 'POST',
        url: '/activity-center-groups/coupon-group-order/save',
        name: '新增团购订单',
    },
    getGroupGoods: {
        method: 'POST',
        url: '/activity-center-groups/coupon-group-order/coupon/page',
        name: '兑换商品分页',
    },
    uploadGroupFile: {
        method: 'POST',
        url: '/activity-center-groups/coupon-group-order/upload/{module}',
        name: '兑换商品分页',
    },
    exportCouponGroupOrder: {
        method: 'POST',
        url: '/activity-center-groups/coupon-group-order/exportCouponGroupOrder',
        name: '导出团购订单',
    },
    // couponGroupOrderTempSn: {
    //     method: 'POST',
    //     url: '/activity-center-groups/coupon-group-order/CouponGroupOrderTempSn/getByOrderId',
    //     name: '兑换sn列表',
    // },
    couponGroupOrderTempSn: {
        method: 'GET',
        url: '/activity-center-groups/coupon-group-order/sn/page',
        name: '团购订单新增兑换商品列表分页',
    },
    addGoodByNum: {
        method: 'POST',
        url: '/activity-center-groups/coupon-group-order/couponCode/getByNum',
        name: '创建团购订单添加商品数量',
    },
    addGoodBySN: {
        method: 'POST',
        url: '/activity-center-groups/coupon-group-order/couponCode/getBySns',
        name: '创建团购订单添加sn',
    },
    saveGoodBySN: {
        method: 'POST',
        url: '/activity-center-groups/coupon-group-order/temp/save',
        name: '临时SN校验存放',
    },
    operationLog: {
        method: 'POST',
        url: '/activity-center-groups/coupon-group-order/operationLog/Page',
        name: '操作记录列表',
    },
    deleteOrder: {
        method: 'DELETE',
        url: '/activity-center-groups/coupon-group-order/delete',
        name: '删除订单',
    },
    deleteSnCode: {
        method: 'GET',
        url: '/activity-center-groups/coupon-group-order/sn/delete',
        name: '删除订单',
    },
    getOrderDetail: {
        method: 'GET',
        url: '/activity-center-groups/coupon-group-order/detail',
        name: '订单详情',
    },
    exportCashCodeListById: {
        method: 'POST',
        url: '/activity-center-groups/coupon/exportCashCodeListById',
        name: '兑换明细-导出',
    },
    exportCashCodeList: {
        method: 'POST',
        url: '/activity-center-groups/coupon/exportCashCodeList',
        name: '兑换明细-全部导出',
    },
    getDownLoadScope: {
        method: 'GET',
        url: '/activity-center-groups/coupon-group-order/download/scope',
        name: '下载兑换码范围',
    },
    getCodeNum: {
        method: 'GET',
        url: '/activity-center-groups/coupon-group-order/coupon/codeNum',
        name: '礼券可用数量',
    },
    exportCouponGroupOrderByCondition: {
        method: 'POST',
        url: '/activity-center-groups/coupon-group-order/exportCouponGroupOrderByCondition',
        name: '导出团购订单(只查20条记录)',
    },
    exportCashOrderList: {
        method: 'POST',
        url: '/activity-center-groups/coupon/exportCashOrderList',
        name: '导出兑换订单',
    },
    giftDetailExport: {
        method: "POST",
        url: "/manage-system/give/admin/export",
        name: '导出售卖明细',
    },
    getMenuList2new: {
        method: "POST",
        url: "/manage-system/coupon/admin/menuList2new",
        name: '导获取门店所有的菜品(阿派朗点餐) 有规格 new出售卖明细',
    },
    querySuitDish: {
        method: "GET",
        url: "/manage-system/coupon/admin/querySuitDish/{couponId}",
        name: '餐饮优惠券列表中适用商品查看',
    },
    thirdReserveList: {
        method: "POST",
        url: "/activity-center-groups/thirdReserve/page",
        name: '预约库存分页',
    },
    thirdReserveExport: {
        method: "POST",
        url: "/activity-center-groups/thirdReserve/export",
        name: '预约名单导出',
    },
    // thirdReserveSave: {
    //     method: "POST",
    //     url: "/activity-center-groups/thirdReserve/save",
    //     name: '新增预约库存',
    // },
    thirdReserveSave: {
        method: "POST",
        url: "/activity-center-groups/thirdReserve/updateDesc",
        name: '更新入园提醒信息',
    },
    thirdReserveGet: {
        method: "POST",
        url: "/activity-center-groups/thirdReserve/getDesc",
        name: '获取入园提醒信息',
    },
    staffHelpUserReserve: {
        method: "POST",
        url: "/activity-center-groups/thirdReserve/staffHelpUserReserve",
        name: '后台帮用户预约',
    },
    userReserveDay: {
        method: "POST",
        url: "/activity-center-groups/thirdReserve/day",
        name: '每天的预约情况',
    },
    updateStockDay: {
        method: "POST",
        url: "/activity-center-groups/thirdReserve/updateStockDay",
        name: '修改容量 传id,stockNum',
    },
    queryBatchOfferByPage: {
        method: "POST",
        url: "/manage-system/offerCoupon/queryBatchOfferByPage",
        name: '分页查询批量发放优惠券列表',
    },
    querySingleOfferByPage: {
        method: "POST",
        url: "/manage-system/offerCoupon/querySingleOfferByPage",
        name: '分页查询单独发放优惠券列表',
    },
    batchOfferCoupon: {
        method: "POST",
        url: "/manage-system/offerCoupon/batchOfferCoupon",
        name: '批量发放优惠券',
    },
    singleOfferCoupon: {
        method: "POST",
        url: "/manage-system/offerCoupon/singleOfferCoupon",
        name: '单独发放优惠券',
    },
    queryFailureRecord: {
        method: "POST",
        url: "/manage-system/offerCoupon/queryFailureRecord",
        name: '查看失败数据',
    },
    downLoadImportExcel: {
        method: "GET",
        url: "/manage-system/offerCoupon/downLoadImportExcel/{batchOfferId}",
        name: '下载导入表格',
    },
    batchOfferTemplateUrl: {
        method: "GET",
        url: "/manage-system/offerCoupon/batchOfferTemplateUrl",
        name: '下载表格模板',
    },
    closeDay: {
        method: "POST",
        url: "/activity-center-groups/thirdReserve/closeDay",
        name: '开关园区',
    },
    queryReserve: {
        method: "POST",
        url: "/activity-center-groups/thirdReserve/queryReserve",
        name: '预约信息查询',
    },
    cacelUserReserve: {
        method: "POST",
        url: "/activity-center-groups/thirdReserve/cacelUserReserve",
        name: '取消用户预约 传id',
    },
    userReserve: {
        method: "POST",
        url: "/activity-center-groups/thirdReserve/userReserve",
        name: '用户预约',
    },

}